module.exports = "/assets/data/d89a6f7d87152e55c1a1a00b2ac51e0c-GU22.data.json";